export const REGRAS_PROCESSAMENTO_BORDERO_TITLE = 'Regras de Processamento de Borderôs';
export const VALOR_LIMITE_BOLETO_FIELD_TITLE = 'Valor Limite Notificação com Boleto';
export const PRAZO_RECALCULO_FIELD_TITLE = 'Prazo para Recálculo';
